<template>
  <p v-if="text !== null" class="color--pinkred-110 text__error mb-0" :style="styleObj">
    {{ text }}
  </p>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
    nudgeLeft: {
      type: String,
      default: '0',
    },
    right: {
      type: Boolean,
      defalut: false,
    },
  },
  computed: {
    styleObj() {
      const d = this.nudgeLeft || 0
      const left = parseInt(d, 10)
      return {
        fontSize: '12px !important',
        marginLeft: `${left}px`,
        textAlign: this.right ? 'right' : 'left',
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
